import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-call-queue-list',
  templateUrl: './call-queue-list.component.html',
  styleUrls: ['./call-queue-list.component.css']
})
export class CallQueueListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
